import { render, staticRenderFns } from "./AwardsPhotoAlbum.vue?vue&type=template&id=b5eab598&scoped=true"
import script from "./AwardsPhotoAlbum.vue?vue&type=script&lang=js"
export * from "./AwardsPhotoAlbum.vue?vue&type=script&lang=js"
import style0 from "./AwardsPhotoAlbum.vue?vue&type=style&index=0&id=b5eab598&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eab598",
  null
  
)

/* custom blocks */
import block0 from "./AwardsPhotoAlbum.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports